module.exports = __webpack_public_path__ + "img/Premium Icon.ec41508c.svg";